import { kErrorCodeAuthError } from '@/constants/constants-error-codes'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { ExternalStorageAuthorizeResponse, ExternalStorageAuthorizeResponseSchema } from '@/settings/schemas/external-storage-schema'
import * as Sentry from '@sentry/browser'
import { getAuth } from 'firebase/auth'
import { nanoid } from 'nanoid'

export default async function getExternalStorageAuthorizeUrl(path: string): Promise<ExternalStorageAuthorizeResponse> {
  const sentryTransactionId = nanoid()

  try {
    const token = await getAuth().currentUser?.getIdToken()
    if (!token) throw Error(kErrorCodeAuthError)

    const requestOptions: RequestInit = {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Transaction-Id': sentryTransactionId,
        Authorization: `Bearer ${token}`,
      },
      method: 'GET',
    }

    const apiUrl = kPaxtonAppApiRESTBaseUrl() + path
    const response = await fetch(apiUrl, requestOptions)
    const data = await response.json()

    if (!response.ok) {
      Sentry.withScope((scope) => {
        scope.setTags({ transaction_id: sentryTransactionId })
        Sentry.captureException(new Error(`Fetch error - status: ${response.status}, detail: ${JSON.stringify(data)}`), {
          extra: { requestUrl: apiUrl, response: JSON.stringify(response), data: JSON.stringify(data) },
        })
      })
      throw new Error(`Fetch error - status: ${response.status}, detail: ${JSON.stringify(data)}`)
    }

    return ExternalStorageAuthorizeResponseSchema.parse(data)
  } catch (e) {
    Sentry.withScope((scope) => {
      scope.setTags({ transaction_id: sentryTransactionId })
      Sentry.captureException(e, { extra: { onLine: navigator.onLine, cookieEnabled: navigator.cookieEnabled } })
    })
    throw e
  }
}
